import { useId } from 'react'
import type { SelectHTMLAttributes } from 'react'
import styles from './ui.module.css'

type Props = SelectHTMLAttributes<HTMLSelectElement> & {
  label: string
  hideLabel?: boolean
  options: ReadonlyArray<{ value: string; label: string }>
}

export function Select({ label, hideLabel = false, options, id, ...rest }: Props) {
  const generated = useId()
  const selectId = id ?? generated
  return (
    <div className={styles.field}>
      <label className={hideLabel ? 'dp-sr-only' : styles.label} htmlFor={selectId}>
        {label}
      </label>
      <select id={selectId} className={styles.select} {...rest}>
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  )
}
